import React from 'react';
import DatePicker from 'react-datepicker';
import TimetableIcon from 'mdi-react/TimetableIcon';
import moment from 'moment';

const renderLotteryDatePickerField = ({ input, meta }) => {
  const value = input.value;
  let selected = null;
  if (value) {
    const parsed = moment(value);
    selected = parsed.isValid() ? parsed.toDate() : null;
  }

  return (
    <div className="form__form-group-input-wrap">
      <div className="date-picker lottery-form-date-picker">
        <div className="form__form-group-field">
          <DatePicker
            selected={selected}
            onChange={(date) => {
              input.onChange(
                date ? moment(date).format('YYYY-MM-DDTHH:mm') : ''
              );
            }}
            showTimeSelect
            timeFormat="p"
            timeIntervals={15}
            dateFormat="Pp"
            placeholderText="DD / MM / YYYY  -- : --"
            disabledKeyboardNavigation
          />
          <div className="form__form-group-icon">
            <TimetableIcon />
          </div>
        </div>
      </div>
      {(meta?.touched || meta?.submitFailed) && meta?.error && (
        <span className="form__form-group-error">{meta.error}</span>
      )}
    </div>
  );
};

export default renderLotteryDatePickerField;
